(function IIFE() {
    'use strict';

    /////////////////////////////

    function UserFollowingFactory($resource, Config) {
        'ngInject';

        return $resource(Config.HAUSSMANN_HOST + '/_ah/api/lumsites/v1/social/subscription/:target/list', {}, {
            list: {
                isArray: false,
                method: 'GET',
                params: {
                    target: 'following',
                },
            },
        });
    }

    /////////////////////////////

    angular.module('Factories').factory('UserFollowingFactory', UserFollowingFactory);
})();
